<template>

  <div class="container">

    <div class="handle-box-search">



      <!-- <el-button type="primary" icon="el-icon-search" @click="searchdriverDanLists">搜索</el-button> -->
      <el-button @click="add_isShow=!add_isShow">添加</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

    </div>

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">


      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <!-- 表格下拉 -->


            <el-form-item label="到期天数:">
              <span>{{ props.row.signing_end_time_day_set }}天</span>
            </el-form-item>



          </el-form>
        </template>
      </el-table-column>






      <el-table-column prop="star_point_set" label="星级分">
      </el-table-column>

      <el-table-column prop="monitor_point_set" label="表现分">
      </el-table-column>


      <el-table-column prop="level_set.alias" label="段位等级">
      </el-table-column>

      <el-table-column prop="driver_level_set" label="司机等级">
      </el-table-column>


      <el-table-column prop="city.name" label="城市">
      </el-table-column>

      <el-table-column prop="cancel_order_set" label="销单率">
        <template slot-scope="scope" v-if="scope.row.cancel_order_set !=null">
          {{scope.row.cancel_order_set}}%
        </template>
      </el-table-column>



      <el-table-column label="操作">
        <template slot-scope="scope">

          <el-dropdown split-button type="primary"
            @click="edit_isShow = !edit_isShow; edit_data = scope.row.driver_dan_set_code; " trigger="click">

            编辑

            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item @click.native="del(scope.row.driver_dan_set_code)">删除段位</el-dropdown-item>

            </el-dropdown-menu>

          </el-dropdown>

        </template>
      </el-table-column>

    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>




    <!-- 添加组件 -->
    <addDriverDan :isShow="add_isShow" @onSubmit="driverDanLists"></addDriverDan>

    <!-- 编辑组件 -->
    <editDriverDan :isShow="edit_isShow" :data="edit_data" @onSubmit="driverDanLists"></editDriverDan>

  </div>

</template>

<script>
  import addDriverDan from './addDriverDan.vue';
  import editDriverDan from './editDriverDan.vue';
  var _this;
  export default {
    components: {
      addDriverDan,
      editDriverDan

    },

    data() {
      return {


        add_isShow: false,

        edit_isShow: false,
        edit_data: '',



        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.driverDanLists();
    },

    methods: {

      del(code) {

        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {

          _this.$post(
              "/driver/delDriverDanSetSubmit", {
                driver_dan_set_code: code
              }
            )
            .then(res => {


              _this.$message.success(res.msg);
              _this.driverDanLists();

            }).catch((err) => {

            })

        }).catch(() => {

          _this.$message({
            message: '已取消删除',
            duration: 1500
          });

        });


      },

      cityChange(val) {

        _this.search_data.city_code = val;
        if (val != '') {

          _this.$post(
            "/city/getCityDetails", {
              city_code: val
            }
          ).then(res => {

            _this.company_name = res.data.company.name;

          }).catch((err) => {

          })

        } else {
          _this.company_name = '';
        }



      },


      //搜索的下拉框弹出触发
      cityVisibleChange(val) {
        if (val && _this.options_city_code.length < 1) {
          // 请求公司管理接口获取公司唯一编码
          _this.$post(
            "/city/cityLists",
            _this.city_options_data
          ).then(res => {
            _this.options_city_code = res.data

          }).catch((err) => {

          })
        }

      },

      searchdriverDanLists() {

        _this.search_data.page = 1;
        _this.driverDanLists();

      },
      // 搜索司机日志列表
      driverDanLists() {
        _this.$post(
            "/driver/driverDanSetLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {


            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.driverDanLists();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].driver_code);

        }
        _this.delDriverSubmit_data.driver_code_array = datalist;
      },
      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }
</style>